import {
  DatePicker,
  Button,
  Form,
  Input,
  Row,
  Col,
  Select,
  InputNumber,
} from "antd";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  MailOutlined,
  FileTextOutlined,
  IdcardOutlined,
} from "@ant-design/icons";
import useSections from "hooks/useAgeSections";

export default function CategorieForm({ form, onSubmit }) {
  const { t } = useTranslation();
  const [errors, setErrors] = useState({});
  const { getAllSections } = useSections();
  const agesections = useSelector(
    (state) => state.agesection.agesections || []
  );
  const getAgeSectionLabel = (ageSectionId) => {
    const section = agesections.find((s) => s.id === ageSectionId);
    return section ? `${section.minAge}-${section.maxAge} ans` : "N/A";
  };
  const [newCategory, setNewCategory] = useState([]);

  useEffect(() => {
    getAllSections();
  }, []);

  return (
    <Form
      layout="vertical"
      name="Categorie_Form"
      id="Categorie_Form"
      form={form}
      onFinish={(values) => {
        const finalValues = {
          ...values,
          ageSectionId: Number(values.ageSectionId),
        };

        onSubmit(finalValues);
      }}
      style={{
        maxWidth: 600,
        margin: "0 auto",
        marginTop: "30px",
        padding: "20px",

        background: "#fff",
      }}
    >
      <Row gutter={16}>
        {/* Champ Nom */}
        <Col xs={24} md={12}>
          <Form.Item
            label={
              <span style={{ fontWeight: "bold", color: "#333" }}>
                {t("supplements.table.column.name")}
              </span>
            }
            name="name"
            rules={[
              {
                required: true,
                message: t("supplements.crud.form.error.label.required.name"),
              },
              {
                min: 3,
                message: t("supplements.crud.form.error.label.name.minLength"),
              },
            ]}
          >
            <Input
              className="custom-input"
              style={{
                borderRadius: "8px",
                padding: "10px",
                border: "1px solid #ddd",
                boxShadow: "inset 0px 1px 3px rgba(0, 0, 0, 0.1)",
                height: "40px", // Assure que la hauteur est la même
              }}
              placeholder={t("supplements.crud.form.placeholder.name")}
            />
          </Form.Item>
        </Col>

        {/* Champ Prix */}
        <Col xs={24} md={12}>
          <Form.Item
            label={
              <span style={{ fontWeight: "bold", color: "#333" }}>
                {t("supplements.table.column.price")}
              </span>
            }
            name="price"
            rules={[
              {
                required: true,
                message: t("supplements.crud.form.error.label.required.price"),
              },
              {
                type: "number",
                min: 100,
                message: t("supplements.crud.form.error.label.price.minValue"),
              },
            ]}
          >
            <InputNumber
              min={100}
              style={{
                width: "100%",
                height: "40px",
                borderRadius: "8px",
                padding: "10px",
                border: "1px solid #ddd",
                boxShadow: "inset 0px 1px 3px rgba(0, 0, 0, 0.1)",
                textAlign: "center",
                display: "flex",
                alignItems: "center",
              }}
              className="custom-input"
              placeholder={t("supplements.crud.form.placeholder.price")}
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault(); // Bloque l'entrée des lettres
                }
              }}
            />
          </Form.Item>
        </Col>
        {/* Champ Description */}
        <Col xs={24}>
          <Form.Item
            label={
              <span style={{ fontWeight: "bold", color: "#333" }}>
                {t("supplements.table.column.description")}
              </span>
            }
            name="description"
            rules={[
              {
                required: true,
                message: t(
                  "supplements.crud.form.error.label.required.description"
                ),
              },
              {
                min: 5,
                message: t(
                  "supplements.crud.form.error.label.description.minLength"
                ),
              },
            ]}
          >
            <Input.TextArea
              prefix={<FileTextOutlined style={{ color: "#f3db56" }} />}
              className="custom-input"
              rows={4}
              style={{
                borderRadius: "8px",
                padding: "10px",
                border: "1px solid #ddd",
                boxShadow: "inset 0px 1px 3px rgba(0, 0, 0, 0.1)",
                resize: "none",
              }}
              placeholder={t("supplements.crud.form.placeholder.description")}
            />
          </Form.Item>
        </Col>

        {/* Champ Section d'âge associée */}
        <Col xs={24}>
          <Form.Item
            label={
              <span style={{ fontWeight: "bold", color: "#333" }}>
                {t("supplements.table.column.age_section")}
              </span>
            }
            name="ageSectionId"
            rules={[
              {
                required: true,
                message: t(
                  "supplements.crud.form.error.label.required.age_section" 
                ),
              },
            ]}
            validateStatus={errors.ageSectionId ? "error" : ""}
            help={errors.ageSectionId}
          >
            <Select
              className="w-full"
              // mode={"multiple"}
              options={agesections.map((s) => ({
                value: s.id,
                label: `${s.minAge}-${s.maxAge} ans`,
              }))}
              placeholder={
                t("supplements.crud.form.placeholder.age_section") 
              }
              showSearch
              filterOption={(input, option) =>
                option.label.toLowerCase().includes(input.toLowerCase())
              }
              style={{
                borderRadius: "8px",
                border: "1px solid #ddd",
                boxShadow: "inset 0px 1px 3px rgba(0, 0, 0, 0.1)",
              }}
            />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
}

{
  /* Ajout du Select */
}
//       <div className="mt-4">
//         <label className="block mb-2">Section d'âge associée</label>
//         <Select
//           className="w-full"
//           options={agesections.map((s) => ({
//             value: s.id,
//             label: `${s.minAge}-${s.maxAge} ans`,
//           }))}
//           value={newCategory.ageSectionId}
//           onChange={(value) => setNewCategory({ ...newCategory, ageSectionId: value })}
//           allowClear
//           showSearch
//           style={{ borderColor: errors.ageSectionId ? "red" : undefined }}
//         />
//         {errors.ageSectionId && <p className="text-red-500">{errors.ageSectionId}</p>}
//       </div>
